/**
 * Classe com funções genéricas para os grids
 *
 * @author: Adalto Junior adaltojunior@sagaranatech.com Date: 03/01/2013 Time:
 *          16:42
 *
 */


Greenmile.Grid = Greenmile.Grid || {};

Greenmile.Grid.GeneralFunctions = {

    formatUnitSystem: function (valueInMeters) {
        const unitSystem = Monet.Session.User['unitSystem'];
        const abreviation = {
            'METRIC': 'UnitSystems.Kilometers.abbreviation',
            'NON_METRIC': 'UnitSystems.Miles.abbreviation'
        };

        if (valueInMeters) {  
            const unitValue = unitSystem === 'METRIC' ? (valueInMeters / 1000) : (valueInMeters * 0.000621371);
            return new Monet.Format.DECIMAL(unitValue).format().getValue() + ' ' + Monet.I18n.getResourcesByKey(abreviation[unitSystem]);
        }

        return '';
    },

    appendMenu: function (element, template) {
        $(element + " td .menuContainer").append(template());
    },

    clearMenu: function () {
        $(".routeMenu").remove();
    },

    /**
     * If some day the grid to pass contain others values like numbers, the function must be updated,
     * but today exists only TEXT fields.
    */
    getDataFilteredByClient: function(activesFilters, arrayOfData) {
        let data = arrayOfData;

        activesFilters.forEach(filter => {
            data = data.filter(item => {
                const selectedItem = item[filter.attr];
                let value;

                if (selectedItem?.$display === null) {
                    value = null;
                } else {
                    value = selectedItem.$display ? selectedItem?.$display : selectedItem;
                }

                if (value) {
                    const parsedItem = String(value).toUpperCase();
                    const filterEq = String(filter.eq).toUpperCase();
                    
                    if(filter?.matchMode === 'EXACT') {
                        return parsedItem === filterEq;
                    } else if (filter?.matchMode === 'ANYWHERE') {
                        return parsedItem.includes(filterEq);
                    } else if (filter?.matchMode === 'END') {
                        return  parsedItem.endsWith(filterEq);
                    } else if (filter?.matchMode === 'START') {
                        return  parsedItem.startsWith(filterEq);
                    }
                }
            });
        });

        return data;
    }

};